import React from 'react';
import possibilityImage from '../../assets/team.png';
import './possibility.css';

const Possibility = () => (
  <div className="gpt3__possibility section__padding" id="possibility">
    <div className="gpt3__possibility-image">
      <img src={possibilityImage} alt="possibility" />
    </div>
    <div className="gpt3__features-container__feature-title">
      <div />
      <h1>ABOUT US</h1>
    </div>
    <div className="gpt3__possibility-content">
      <h1 className="gradient__text">We are Visitor Advisor family</h1>
      <p>Yet bed any for travelling assistance indulgence unpleasing. Not thoughts all exercise blessing. Indulgence way everything joy alteration boisterous the attachment. Party we years to order allow asked of.</p>
      <h4>Request Early Access to Get Started</h4>
    </div>
  </div>
);

export default Possibility;
